import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

export class ModalOptions {
  public static DEFAULT_MODAL_OPTIONS: NgbModalOptions = {
    backdrop: 'static',
    keyboard: true,
    // windowClass: 'modal-50',
  };

  public static LARGE_MODAL_OPTIONS: NgbModalOptions = {
    backdrop: 'static',
    keyboard: true,
    size: 'lg',
    // windowClass: 'modal-80',
  };

  public static SMALL_MODAL_OPTIONS: NgbModalOptions = {
    backdrop: 'static',
    keyboard: true,
    size: 'sm',
  };
}
